import { dispatch, useSelector } from '@state/store';
import { FiltersSideBar } from '@components/filters/v2/FiltersSideBar';
import React from 'react';
import {
  getDealFinderResultsData,
  getHasAppliedFilters
} from '@state/slices/deal-finder-results/dealFinderResultsSelectors';
import { Filter } from '@model/iceberg';
import { FiltersAdapter } from '@model/iceberg/filters/deal-finder/filters-adapter';
import { setFilters } from '@state/slices/deal-finder-results/dealFinderResultsSlice';

export interface FiltersSideBarContainerProps {
  title?: boolean;
  isLeftFilter?: boolean;
}

export const FiltersSideBarContainer = (props: FiltersSideBarContainerProps) => {
  const {
    facets: { filters }
  } = useSelector(getDealFinderResultsData);
  const hasAppliedFilters: boolean = useSelector(getHasAppliedFilters);
  const handleOnFiltersChange = (payload: Array<Filter>) => dispatch(setFilters(FiltersAdapter.getQuery(payload)));
  const handleOnReset = () => dispatch(setFilters({}));
  return (
    <FiltersSideBar
      {...props}
      filters={filters}
      hasAppliedFilters={hasAppliedFilters}
      onChange={handleOnFiltersChange}
      onReset={handleOnReset}
      title
      isLeftFilter={props.isLeftFilter}
    />
  );
};
